import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'unijob',
      storage,
      whitelist: ['auth', 'user', 'main'],
    },
    reducers,
  );

  return persistedReducer;
};
